import React, { useEffect } from 'react';
import { AxiosResponse } from 'axios';
import { FileUpload, FileUploadParam, Form, SonForm, SubmitButton, useForm } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useModalContext } from '../../../components/organisms/ModalDialog/ModalContext';
import { useDelayed } from '../../../hooks/useDelayed';
import { FileUploadResponseErrors, getErrorFilesFromResponse } from '../../../_lib/FileUpload';
import { InteractionStatus } from '../../../types/InteractionStatus';

export type SharedFilesUploadForm = {
  form: SonForm<FileUploadParam<'fileData'>>;
};

const mapFileUploadReponseErrors = (errorResponse: AxiosResponse<any>) => {
  const fileErrors = getErrorFilesFromResponse(errorResponse);
  if (fileErrors) {
    return <FileUploadResponseErrors response={errorResponse} status={InteractionStatus.FAIL} />;
  }
};

/**
 * Form to upload shared files.
 */
export function SharedFilesUploadForm({ form }: SharedFilesUploadForm) {
  const { t } = useSonTranslation('SharedFiles');
  const { preventModalClose, closeModal } = useModalContext();
  const delayedModalClose = useDelayed(closeModal);

  const { formProps, params, fetchState } = useForm({ form, onSuccess: delayedModalClose });

  const fileData = params.getByName('fileData');

  useEffect(() => {
    if (fetchState.type === 'loading') {
      preventModalClose(true);
    }

    if (fetchState.type === 'success' || fetchState.type === 'error') {
      preventModalClose(false);
    }
  }, [fetchState.type, preventModalClose]);

  return (
    <div className="shared-files__upload-form">
      <Form {...formProps}>
        <FileUpload headingLabel={t('forms.upload.headingLabel')} param={fileData} formRef={formProps.ref} />
        <SubmitButton
          buttonLabel={t('forms.upload.submitButton')}
          messageSuccess={t('forms.upload.success')}
          messageSending={t('forms.upload.sending')}
          messageFail={t('forms.upload.fail')}
          fetchState={fetchState}
          active={fetchState.type !== 'loading' && fetchState.type !== 'success'}
          customErrorResponseMapper={mapFileUploadReponseErrors}
        />
      </Form>
    </div>
  );
}
